import { Button, Card, Heading, Paragraph, Box } from '@deckee/deck-hand';
import React, { FC } from 'react';

export interface CourseCardInterface {
  name: string;
  description: string[];
  cost: number;
  url: string;
  imageUrl: string;
  buttonText?: string;
  providerName: string;
}

interface CourseCardProps extends CourseCardInterface {
  role: string;
  onSelectCourse: (course: CourseCardInterface) => void;
}

const CourseCard: FC<CourseCardProps> = ({
  name,
  description,
  cost,
  imageUrl,
  url,
  role,
  buttonText,
  providerName,
  onSelectCourse,
}) => {
  const handleClick = () => {
    onSelectCourse({ name, description, cost, url, imageUrl, providerName });
  };
  return (
    <Card role={role}>
      <Card.HeadImage imageUrl={imageUrl} />
      <Card.Body>
        <Heading level={4}>{name}</Heading>
        <Box fontSize="1" color="darkergrey">
          {providerName}
        </Box>
        {description.map((d, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Paragraph key={i}>{d}</Paragraph>
        ))}
        <Paragraph mb={3} fontSize="20px">
          {cost !== 0 &&
            `${cost.toLocaleString('en-AU', {
              currency: 'AUD',
              style: 'currency',
            })} AUD`}
        </Paragraph>
        <Button wide onClick={handleClick}>
          {/* Weird bug where in strapi, if you entered buttonText, and then cleared it would be an empty string, and not undefined */}
          {buttonText || 'Enroll now'}
        </Button>
      </Card.Body>
    </Card>
  );
};

CourseCard.defaultProps = {
  buttonText: 'Enroll now',
};

export default CourseCard;
